import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48063L11.4806 5H23V21H11.2678C11.7356 20.1025 12 19.0821 12 18C12 14.4102 9.08985 11.5 5.5 11.5C3.75351 11.5 2.16789 12.1888 1 13.3096V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9083 18.002L6.04998 13.0878L4.62771 14.4939L7.10728 17.002L-0.00195312 17.002V19.002L7.10728 19.002L4.62771 21.5101L6.04999 22.9162L10.9083 18.002Z"}}]};

const FolderImportFilled = Vue.extend<IconProps>({
  name: 'FolderImportFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'folder-import-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FolderImportFilled;
